import { http } from "./http";

/**
 * Active-flow lookup: turns an applicationId into the flow that the user
 * should land in when they click "Design" on the Applications list.
 * Mirrors ActiveFlowDto in the .NET FlowBuilderController.
 */
export interface ActiveFlow {
  applicationId: number;
  applicationName: string;
  flowId: number;
  flowName: string;
  initialNodeId: number | null;
}

export const flowsApi = {
  getActiveFlow: (applicationId: number) =>
    http<ActiveFlow>(`/api/applications/${applicationId}/active-flow`),
};
